import React from "react";
import ProjectSlider from "../Sliders/ProjectSlider";
import "../Stylings/projectSlider.css";

const Projects = () => {
  return (
    <div className="bg-gray-100">
      <div id="projects" className=" xl:max-w-screen-xl xl:mx-auto">
        <ProjectSlider>
          {/*  */}
          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/4443646bac70015c710729ae2d8b945c11f7bdd1-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Buy It Ecommerce Store
                </h1>
                <p className="py-4 font-bold text-sm">
                  Ecommerce / Stripe Payments
                </p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="p-3 my-4 mr-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://buyit-shoes.netlify.app">Live Site</a>
                  </button>
                  <button className=" p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://github.com/developer-junaid/Buy-It">
                      Github
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}

          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/e457e4b166e7b4ad527d8c8a723e35253659670c-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Memories Social Media App
                </h1>
                <p className="py-4 font-bold text-sm">
                  Social Media / Management
                </p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://memories-manager.netlify.app">Live Site</a>
                  </button>
                  <button className=" p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://github.com/developer-junaid/MERN-Memories-App">
                      Github
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}

          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/56d74a8100b504dec86bc299f0fd01f152ab2a4f-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Diaries Manager
                </h1>
                <p className="py-4 font-bold text-sm">
                  Productivity / Management
                </p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://diaries-manager.web.app/signin">
                      Live Site
                    </a>
                  </button>
                  <button className=" p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://github.com/developer-junaid/Diaries-Manager-App">
                      Github
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/4c6d3cb52b25c7595cf97f0f1852e56aa018bf29-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Apkhub (Apps Listing)
                </h1>
                <p className="py-4 font-bold text-sm">Apps Listing / Games</p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://apkhub.vercel.app/"> Live Site</a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}

          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/7fce4fa5fcc39c226de66423bbde336c34bc75ff-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Nike Store
                </h1>
                <p className="py-4 font-bold text-sm">Ecommerce / Store</p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://nike-shoe-store.netlify.app/">Live Site</a>
                  </button>
                  <button className=" p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://github.com/developer-junaid/Nike-Shoe-Store">
                      Github
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}

          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/e5f40e8a98f7a02aeb1fe7f624e46c249b7b8b73-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Todo List
                </h1>
                <p className="py-4 font-bold text-sm">Todo List / Management</p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://todo-list-serverless.netlify.app/">
                      Live Site
                    </a>
                  </button>
                  <button className=" p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://github.com/developer-junaid/Jamstack-Todolist">
                      Github
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/724e112a50c1219b2b84506ef3b858521c1c0339-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Blog Website
                </h1>
                <p className="py-4 font-bold text-sm">Blog / Marketing</p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://techberg-blog.netlify.app/">Live Site</a>
                  </button>
                  <button className=" p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://github.com/developer-junaid/Blog-Site/">
                      Github
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}

          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/eff432d273cc41f14edfec19dc21320fa0aa8bdf-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  MenaJobs (Job Portal)
                </h1>
                <p className="py-4 font-bold text-sm">
                  Job Website / Job Portal
                </p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
              </div>
            </div>
          </div>
          {/*  */}

          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/ba1856299e5034b06d2027bc93a3e7bd956898df-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  React NFT Listing App
                </h1>
                <p className="py-4 font-bold text-sm">Web3 / NFT Listing</p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://react-nft-project.netlify.app/">
                      Live Site
                    </a>
                  </button>
                  <button className=" p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://github.com/developer-junaid/React-NFT-App">
                      Github
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/89d2bdada83dd0e67bda7ffade5314254a2d27ba-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  TransferKrypt
                </h1>
                <p className="py-4 font-bold text-sm">
                  Transfer Crypto / Blockchain
                </p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://transferkrypt.netlify.app/">Live Site</a>
                  </button>
                  <button className=" p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://github.com/developer-junaid/Transfer-Krypt">
                      Github
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}

          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/ef1ea0d396d8c5dabe6e61a89291e3ad8382c25d-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Zen Coin
                </h1>
                <p className="py-4 font-bold text-sm">DApp / DeFi</p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://zen-coin.netlify.app/">Live Site</a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}

          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/2b4bc30dd9ba62788dd5c4bf5247178db66f291b-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Uber Eats UI
                </h1>
                <p className="py-4 font-bold text-sm">UI / Food App</p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://uber-eats-landing-page.netlify.app/">
                      Live Site
                    </a>
                  </button>
                  <button className=" p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://github.com/developer-junaid/Uber-Eats-Clone">
                      Github
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/dcba584d6d3ecd421173f9f0f2b7d032b266ffbe-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Games Landing UI
                </h1>
                <p className="py-4 font-bold text-sm">UI / Glass Effect</p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://glass-ui-website.netlify.app/">
                      Live Site
                    </a>
                  </button>
                  <button className=" p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://github.com/developer-junaid/Glass-Website-CSS">
                      Github
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}

          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/f1b7cd6852dfc546c1ac28e40e722bc3a91415f8-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Decontex Polska
                </h1>
                <p className="py-4 font-bold text-sm">Gatsby / Performance</p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://decontex.netlify.app/">Live Site</a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}

          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/820ac8dfb9d0413deba486dd5409af02d7297620-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Blend: Report Management
                </h1>
                <p className="py-4 font-bold text-sm">
                  Frontend / Report Management
                </p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://app.blend.report/login">Live Site</a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}
          {/*  */}

          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/323d2f87f2c7be23e9d810c6d1c6382bf168943e-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Corona Virus Tracker
                </h1>
                <p className="py-4 font-bold text-sm">ReactJs / API</p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://online-corona-tracker.web.app/">
                      Live Site
                    </a>
                  </button>
                  <button className=" p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://github.com/developer-junaid/Corona-Virus-Tracker">
                      Github
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}
          {/*  */}

          <div className="gap-8 changePadding flex flex-col py-8 px-20 md:flex-row justify-center items-center">
            <div className="p-4 shadow-md gap-8 md:flex md:flex-row justify-center items-center">
              <div className="py-4 w-full changeWidth">
                <img
                  src="https://cdn.sanity.io/images/fxul9ln3/production/d15501070a60ed9d6a321fa42d15b66413fc4020-1920x1080.png"
                  alt=""
                />
              </div>
              <div className="w-full">
                <h1 className="changeH1Font text-2xl text-gray-700 font-bold">
                  Mobile First Diaries UI
                </h1>
                <p className="py-4 font-bold text-sm">UI / Mobile First</p>
                <h6 className="text-sm font-semibold">Challenges Faced</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Complex and time-consuming car leasing processes
                  </li>
                  <li>Lack of transparency in pricing and terms</li>
                </ul>
                <h6 className="text-sm font-semibold">Benefits Delivered</h6>
                <ul className="px-4 text-xs list-disc my-2">
                  <li className="pb-2">
                    Reduced leasing time by 40% through an intuitive app
                    interface
                  </li>
                  <li>Enhanced transparency with clear pricing and terms</li>
                </ul>
                <div>
                  <button className="mr-4 p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://mobile-first-design.netlify.app/">
                      Live Site
                    </a>
                  </button>
                  <button className=" p-3 my-4  text-xs font-semibold border-2 rounded border-black">
                    <a href="https://github.com/developer-junaid/Mobile-First-Landing">
                      Github
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/*  */}
        </ProjectSlider>
      </div>
    </div>
  );
};

export default Projects;
